import React from 'react';
import {
  Grid,
  FormControlLabel,
  Switch,
  Typography,
  Slider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { GapStylingConfig } from './types';

interface BasicTabProps {
  config: GapStylingConfig;
  onConfigChange: (updates: Partial<GapStylingConfig>) => void;
}

/**
 * Basic tab component for gap styling configuration
 * Handles enabled state, height, opacity, and background type selection
 */
const BasicTab: React.FC<BasicTabProps> = ({ config, onConfigChange }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Switch
              checked={config.enabled}
              onChange={(e) => onConfigChange({ enabled: e.target.checked })}
            />
          }
          label="Enable Gap Styling"
        />
      </Grid>

      {config.enabled && (
        <>
          <Grid item xs={12} sm={6}>
            <Typography gutterBottom>Height (px)</Typography>
            <Slider
              value={config.height}
              onChange={(_, value) => onConfigChange({ height: value as number })}
              min={1}
              max={200}
              valueLabelDisplay="auto"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography gutterBottom>Opacity</Typography>
            <Slider
              value={config.opacity}
              onChange={(_, value) => onConfigChange({ opacity: value as number })}
              min={0}
              max={1}
              step={0.1}
              valueLabelDisplay="auto"
            />
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Background Type</InputLabel>
              <Select
                value={config.backgroundType}
                onChange={(e) => onConfigChange({ backgroundType: e.target.value as GapStylingConfig['backgroundType'] })}
              >
                <MenuItem value="color">Solid Color</MenuItem>
                <MenuItem value="gradient">Gradient</MenuItem>
                <MenuItem value="image">Image</MenuItem>
                <MenuItem value="pattern">Pattern</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default BasicTab;